import script from "./Banner.vue?vue&type=script&setup=true&lang=js"
export * from "./Banner.vue?vue&type=script&setup=true&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=4ed6c396&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed6c396"]])

export default __exports__